import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner"]

  connect() {
    this.element.addEventListener("turbo:before-fetch-request", () => {
      this.element.classList.add("loading")
    })

    this.element.addEventListener("turbo:frame-render", () => {
      this.element.classList.remove("loading")
    })

    this.element.addEventListener("turbo:frame-load", () => {
      this.element.classList.remove("loading")
    })
  }
}
